import { Typography, Box, DialogContent } from '@mui/material'
import { useTranslation } from 'react-i18next'

import {
  SIZES,
  CLOSE_TYPES,
} from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.constants'
import DialogLayout from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.component'
import DeleteIcon from '@hapana/shared/web/styles/assets/svgs/delete-icon.svg'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'

import { styles } from '../notes-properties.styles'

const ModalDeleteNote = () => {
  const { popDialog } = useDialog()
  const { t } = useTranslation(['checkIn'])

  const handleDelete = () => {
    alert('This note has been deleted compleltely !!')
    popDialog()
  }
  return (
    <DialogLayout
      closeType={CLOSE_TYPES.TEXT}
      closeAction={() => popDialog()}
      size={SIZES.XS}
      primaryAction={{
        label: t('checkIn:alerts.modals.deleteNoteTitle'),
        action: handleDelete,
      }}
    >
      <DialogContent>
        <Box sx={styles.deleteNoteIcon}>
          <DeleteIcon />
        </Box>
        <Typography typography="header2" color="gray.80" sx={styles.deleteNoteText}>
          {t('checkIn:alerts.modals.deleteNoteTitle')}
        </Typography>
        <Typography typography="medium" color="gray.80" sx={styles.deleteNoteText}>
          {t('checkIn:alerts.modals.deleteNoteDescription')}
        </Typography>
      </DialogContent>
    </DialogLayout>
  )
}
export default ModalDeleteNote
